import { useCallback, useContext, useMemo } from "react";
import CampaignsTable from "../components/Campaigns/CampaignsTable";
import { useSetActionButtons } from "../services/ActionButtonsContext";
import { IconPlus } from "@tabler/icons-react";
import { useGetAllCampaigns } from "../api/campaigns";
import { useGetTags } from "../api/tag";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthContext } from "../services/context";
import { getCurrentWorkspace } from "../services/userConfig";
import { openTemplatePickerModal } from "../components/Campaigns/TemplatePickerModal";

const Campaigns = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const page = parseInt(searchParams.get("page") || "1", 10);

  const { user } = useContext(AuthContext);
  const { eventId } = getCurrentWorkspace(user);

  const statusParam = searchParams.get("status");
  const statusFilter = statusParam ? statusParam.split(",") : [];

  const tagsParam = searchParams.get("tagIds");
  const tagsFilter = tagsParam ? tagsParam.split(",") : [];

  const { data: campaigns, isPending } = useGetAllCampaigns({
    eventId,
    page,
    limit: 10,
    status: statusParam || null,
    tagIds: tagsParam || null,
  });

  const { data: availableTags } = useGetTags({
    eventId,
    type: "people",
    subtype: "categoryOfUser",
  });

  const handlePageChange = (newPage) => {
    setSearchParams((params) => {
      params.set("page", newPage.toString());
      return params;
    });
  };

  const handleStatusFilterChange = (status) => {
    setSearchParams((searchParams) => {
      if (!status || status.length === 0) {
        searchParams.delete("status");
        return searchParams;
      }
      searchParams.set("status", status);
      searchParams.set("page", 1);
      return searchParams;
    });
  };

  const handleTagsFilterChange = (tagIds) => {
    setSearchParams((searchParams) => {
      if (!tagIds || tagIds.length === 0) {
        searchParams.delete("tagIds");
        return searchParams;
      }
      searchParams.set("tagIds", tagIds.join(","));
      searchParams.set("page", 1);
      return searchParams;
    });
  };

  const handleCreateCampaign = useCallback(() => {
    openTemplatePickerModal((template) => {
      navigate(`/app/campaigns/create?template=${template.id}`);
    });
  }, [navigate]);

  const actions = useMemo(
    () => [
      {
        label: "Create Campaign",
        icon: <IconPlus />,
        onClick: handleCreateCampaign,
      },
    ],
    [handleCreateCampaign]
  );

  useSetActionButtons(actions);

  return (
    <div>
      <CampaignsTable
        eventId={eventId}
        fetching={isPending}
        records={campaigns?.data || []}
        page={page}
        onPageChange={handlePageChange}
        recordsPerPage={campaigns?.pagination?.perPage || 10}
        totalRecords={campaigns?.pagination?.total || 0}
        statusFilter={statusFilter}
        handleStatusFilterChange={handleStatusFilterChange}
        tagsFilter={tagsFilter}
        handleTagsFilterChange={handleTagsFilterChange}
        availableTags={availableTags || []}
      />
    </div>
  );
};

export default Campaigns;
